import { pageHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const FAQ = lazy(() => import("@/pages/FAQ"));

export const Route = createFileRoute("/_public/faq")({
  head: () => pageHead({ path: "/faq", title: "FAQ — Amorette Questions Answered", description: "Answers to common questions about Amorette membership, verification, Reservations and curated dining experiences." }),
  component: FAQ,
});
